import { useContext, useEffect, useMemo, useState } from "react";
import { tokens } from "../Context/Tokens";
import { Contexto } from "../Context/Contexto";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import { PreAlertaInicial, PreAlertas } from "../Model/Tablas/PreAlertas";
import { Carga } from "../Rutas/Servicios";
import "../index.css"
import { PreAlertaEspana } from "./Modelos";

export default function PreAlerta()
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    
    const datos=[
        PreAlertaInicial
      ]
      const columns=useMemo(() => PreAlertas, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
      var cantidad=0
      const {CambiosCantidad}=useContext(MensajeContActualizacion)

     useEffect(()=>{
        ActualizarDatos();
     },[Cli.Eleccion])

     useEffect(()=>
     {
        if(CambiosCantidad>0)
        {
            ActualizarDatos();
        }
     },[CambiosCantidad])

     const ActualizarDatos=()=>
     {
        
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                
                const historialcargas=Get(Carga.RastreoPreAlertas.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                historialcargas.then(resultado=>Setdata(resultado))
            }
        }

     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            setPageSize,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex,pageSize } = state
    return (
        <>
        
        {data.length===0? <div className="col-12 py-2 py-sm-0">
        <div className="card">
                    <div className="card-body">
                      <div className="accordion" style={{textAlign:"center"}}>
                      <span className="content" >No tiene PreAlertas en España en los últimos 6 meses.</span>
                      </div>
                    </div>
                  </div>
             

                    </div>:<> <div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" >
                     <table  {...getTableProps()} className="table table-hover table-sm table-bordered">
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()}>
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                           {column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
                           {page.map((row: any) => {
                               prepareRow(row)
                               
                               return (
                                   <tr {...row.getRowProps()} >
                                       {row.cells.map((cell: any) => {    
                                           return (
                                            cell.column.Header==="Ver Factura" && cell.value!="-"?
                                            <td {...cell.getCellProps()}>
                                                <a  href={cell.value} > <i className="bi-search" style={{color:"black"}}></i> </a>
                                                    
                                                </td>
                                            :cell.column.Header==="Valor del Producto" && cell.value!="-"?
                                            <td {...cell.getCellProps()} >${cell.render('Cell')}</td>
                                            :
                                            <td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                           );
                                       })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
		  </div>
          {data.length>10?<>
            <div className="col-12 py-2 py-sm-0"><div className="col-sm-12">
            <div className="row">
                <div className="col-sm-9 my-1 px-sm-2">
                <div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
<a>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                   
                   
                </a>
                
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                
                <a >
                <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                    
                   
                   
                </a>
               
            </div>
                </div>
                <div className="col-sm-2 my-1 px-sm-2">
                    <div style={{margin: '5px', justifyContent: 'center', alignItems: 'center'}}>
                        <span>Ver Filas </span> <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}  >
                    {
                        [10,25,50, 100].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))
                    }
                </select>
                    </div>
                
                </div>
                </div></div> </div>
               
            </>:null}
           
        </>
                    }
                   
<PreAlertaEspana></PreAlertaEspana>


            
        
       

        </>
    )
}